import styles from './MobileApp.module.scss'
import { useDispatch } from 'react-redux'
import { fetchMobileApps } from '@/store/slices/stagesSlice/stagesSlice'
import { getUserAgent } from '@/helpers/getUserAgent'
import { useEffect, useState } from 'react'
import { OperatingSystem } from '@/constants'
import { yandexMetrika } from '@/helpers/yandexMetrika'
import { MobileAppLinks } from '@/components/MobileAppLinks/MobileAppLinks'
import { ONELINK_MOBILE_APP } from '@/constants/links'

export const MobileApp = () => {
  const dispatch = useDispatch()
  const [operatingSystem, setOperatingSystem] = useState<OperatingSystem | 'other'>('other')
  const [origin, setOrigin] = useState<string>('')

  useEffect(() => {
    const fetchMobileLinks = async () => await dispatch(fetchMobileApps())

    fetchMobileLinks()
  }, [])

  useEffect(() => {
    if (window) {
      setOrigin(window.location.origin)
    }
  }, [])

  useEffect(() => {
    const operatingSystem = getUserAgent()
    setOperatingSystem(operatingSystem)
  }, [])

  const links = {
    android: {
      link: ONELINK_MOBILE_APP,
      onClick: yandexMetrika.reachGoalButtonClickGooglePlayNew,
      onView: yandexMetrika.reachGoalButtonViewGooglePlayNew,
    },
    ios: {
      link: ONELINK_MOBILE_APP,
      onClick: yandexMetrika.reachGoalButtonClickAppStoreNew,
      onView: yandexMetrika.reachGoalButtonViewAppStoreNew,
    },
    other: {
      link: origin,
      onClick: undefined,
      onView: yandexMetrika.reachGoalButtonViewNotDetected,
    },
  }

  useEffect(() => {
    if (operatingSystem) {
      links[operatingSystem].onView()
    }
  }, [operatingSystem, links])

  const currentLink = links[operatingSystem]

  return (
    <div className={styles.container}>
      <div className={styles.container__content}>
        <h2 className={styles.title}>Оплачивайте парковку ещё&nbsp;быстрее в приложении</h2>
        <p className={styles.description}>
          100+ парковок в системе
          <br />
          150 000+ довольных пользователей
        </p>
        <div className={styles.container__button}>
          <a
            target="_blank"
            className={styles.button}
            href={currentLink.link}
            onClick={currentLink.onClick}
          >
            Скачать приложение
          </a>
          <MobileAppLinks className={styles.appButtons} />
        </div>
      </div>
    </div>
  )
}
